export default __webpack_public_path__ + "static/media/10.0815a1b1.png";